import { render } from "./pageManagerView.vue?vue&type=template&id=c7d7be52"
import script from "./pageManagerView.vue?vue&type=script&lang=js"
export * from "./pageManagerView.vue?vue&type=script&lang=js"

import "./pageManagerView.vue?vue&type=style&index=0&id=c7d7be52&lang=less"

import exportComponent from "E:\\Work\\GPTWeb\\licCode\\lic\\webviewer\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__